import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { DateGregorianDifferences_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Age Difference Calculator - Calculate the Difference Between Two Dates';
const DESCRIPTION = 'Calculate the duration between two dates, whether in Hijri or Gregorian calendars, and calculate the days between two dates using the Days Calculator. Determine the elapsed and remaining time between any two dates.';
const KEYWORDS = 'Age difference calculation, Calculate age difference between two people, Calculate age gap between two people, Age gap calculator, Accurate age difference calculation, Calculate age difference between individuals, Convert age to time difference, Calculate age gap between birthdates, Date difference calculator between specified dates, Calculate age difference between specified dates';
const OG_URL = 'https://do-calculate.com/calculator/en/gregoriandifferences/';
const apiEndpoint = `${SERVER_URL}/${DateGregorianDifferences_EndPoint}`;
function AgeCalculatorGregorian() {
  const [date1, setDate1] = useState('');
  const [date2, setDate2] = useState('');
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const handleDateChange1 = (event) => {
    setDate1(event.target.value);
  };
  const handleDateChange2 = (event) => {
    setDate2(event.target.value);
  };
  const calculateDifferences = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ date1, date2 }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setDifferences(data.differences);
        setError(null);
      } else {
        setDifferences(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
              <div className="border border-light">
                <div className="row">
                  <div>
                    Calculate the duration between two dates, whether in Hijri or Gregorian calendars, and calculate the days between two dates using the Days Calculator. Determine the elapsed and remaining time between any two dates.
                    <br/>                  </div>
                  <br /><hr />
                </div>
                <MobileUnderCalAds/>
                <div className="row">
                  <div className="col">
                    <label htmlFor="dateOfBirth1">Enter the birthdate for the first age</label>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input
                        type="date"
                        id="dateOfBirth1"
                        value={date1}
                        onChange={handleDateChange1}
                        className="form-control"
                        lang='ar'
                      />
                    </div>
                  </div>
                </div>
                <br /><hr /><br />
                <div className="row">
                  <div className="col">
                    <label htmlFor="dateOfBirth2">Enter the birthdate for the second age</label>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <input
                        type="date"
                        id="dateOfBirth2"
                        value={date2}
                        onChange={handleDateChange2}
                        className="form-control"
                        lang='ar'
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col" className='text-center'>
                    <br /><hr />
                    <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateDifferences} disabled={isLoading}>
                      {isLoading ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        'Calculate the Age Difference'
                      )}
                    </button>
                    <br />
                  </div>
                  <hr />
                  <div className="row">
                    <RelatedLinks />
                    <br />
                    <hr />
                  </div>
                  <div className="row">
                    <div className="col">
                      <br />
                      {statusCode === 400 && <div className="alert alert-warning"><b><u> An Error Occurred:</u></b> Please enter a valid birthdate </div>}
                      {differences && (
                        <div>
                          <br />
                          <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                            <b> The age difference is:   </b>
                            {differences.years} years
                            and {differences.months} months
                            and {differences.days} days
                            and {differences.hours} hours
                            and {differences.minutes} minutes
                            and {differences.seconds} seconds
                          </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
        </div>
        <div className="col" >
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.humanCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Calculate the Difference Between Two Dates in Gregorian Calendar: Age Difference Calculation</div>
              <div className="info-section-body">
                <u><h2 style={{ fontSize: '16px' }}>Calculate the Difference Between Two Dates in Gregorian Calendar: Age Difference Calculation</h2></u>
                <p>
                  Age is an important aspect of a person's life, reflecting their experience and maturity over time. Calculating the difference between two dates in the Gregorian calendar requires precise knowledge of the dates and the ability to convert them into a simple time difference. In this article, we will look at how to calculate the age difference between two individuals or between specific dates in the Gregorian calendar.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>The Basic Concept of Age Difference Calculation</h2></u>
                <p>
                  Age difference calculation is the process of determining the number of years, months, and days that separate two specific dates in the Gregorian calendar. This calculation can be used in various contexts, such as calculating the age difference between two individuals or finding the age gap between significant dates like graduation or other occasions.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>How to Calculate the Age Difference Between Birthdates</h2></u>
                  To calculate the age difference between specific birthdates in the Gregorian calendar, you can follow these steps:
                  <ul>
                    <li>
                      Identify the birthdates: Start by identifying the birthdates for which you want to calculate the difference.
                    </li>
                    <li>
                      Convert the dates to days: Simply convert each date into a number of days, starting from the beginning of the Gregorian calendar.
                    </li>
                    <li>
                      Calculate the difference: Subtract one day count from the other to get the age difference in days.
                    </li>
                    <li>
                      Convert the age difference: You can convert the age difference in days into months or years by dividing it by the number of days in a month or a year, respectively. For example, there are approximately 30 days in a month.
                    </li>
                  </ul>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>Using an Age Difference Calculator</h2></u>
                <p>
                  To simplify the process of age difference calculation, you can use an online age difference calculator. These tools provide a quick and accurate calculation of the difference between dates in terms of days, months, and years.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>Applications of Age Difference Calculation</h2></u>
                <p>
                  Age difference calculation can be used in various contexts, such as calculating the age difference between two individuals in a relationship or determining the age gap between significant dates like marriage or moving into a new house. It is also used in administrative and statistical aspects.
                </p>
                <hr />
                <u><h2 style={{ fontSize: '16px' }}>How an Age Difference Calculator Works</h2></u>
                <p>
                  This calculator calculates age differences between two dates in the Gregorian calendar. If you provide two birthdates, the function will return the age differences between them.
                  <br />
                  When using this function, you should pass the Gregorian dates in the correct format, such as "YYYY-MM-DD". If incorrect dates are passed, the function will throw an error and return a message indicating that valid dates must be entered.
                  <br />
                  The calculator returns a result containing the differences in years, months, days, hours, minutes, and seconds.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u><h2>Frequently Asked Questions</h2></u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What Is Age Difference Calculation in the Gregorian Calendar?</h3>
              </div>
              <div className="info-section-body">
                Age difference calculation in the Gregorian calendar is the process of determining the time difference between two birthdates in terms of years, months, and days. This is typically done to find the age difference between individuals or for other purposes.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>How Can Age Difference Between Two Birthdates in the Gregorian Calendar Be Calculated?</h3>
              </div>
              <div className="info-section-body">
                You can calculate the age difference between two birthdates in the Gregorian calendar by following these steps:
                <ol>
                  <li>Identify the birthdates of the two individuals.</li>
                  <li>Convert those dates into a number of days since the start of the Gregorian calendar.</li>
                  <li>Subtract the days' difference to get the age difference in days.</li>
                  <li>If desired, convert the age difference in days into years and months.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>Is There an Age Difference Calculator for the Gregorian Calendar?</h3>
              </div>
              <div className="info-section-body">
                Yes, you can use several online age difference calculators to facilitate this process. These tools calculate the difference accurately and quickly. Simply input the birthdates, and you'll get the difference in years, months, and days.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What Is the Significance of Age Difference Calculation in the Gregorian Calendar?</h3>
              </div>
              <div className="info-section-body">
                Age difference calculation in the Gregorian calendar can be important in various contexts, such as determining the age difference between individuals in personal relationships or for planning significant events and occasions. It is also used in administrative and statistical aspects.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>Can Age Difference Between Two Birthdates Be Calculated Manually?</h3>
              </div>
              <div className="info-section-body">
                Yes, age difference between two birthdates in the Gregorian calendar can be calculated manually by knowing the birthdates and using recognized Gregorian calendar rules. It may require some time and effort but is technically possible.
              </div>
            </div>
          </div>
        </div>
      </div> <br />
    </div>
  );
}
export default AgeCalculatorGregorian;
